import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import DashboardLayout from './dashboard/DashboardLayout';
import Overview from './dashboard/pages/Overview';
import RunCheck from './dashboard/pages/RunCheck';
import History from './dashboard/pages/History';
import FrameworksPage from './dashboard/pages/Frameworks';
import SettingsPage from './dashboard/pages/Settings';
import MyPlan from './dashboard/pages/MyPlan';
import Admin from './dashboard/pages/Admin';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App bg-[#FAFAF5] text-[#0B1F2D] antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Overview />} />
            <Route path="run" element={<RunCheck />} />
            <Route path="history" element={<History />} />
            <Route path="frameworks" element={<FrameworksPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="plan" element={<MyPlan />} />
            <Route path="admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
